
import React from 'react';

export const HowItWorksSection: React.FC = () => {
  return (
    <section id="como-funciona" className="py-8 md:py-20 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-4 md:mb-4">
            Como <span className="text-orange-500">Funciona</span>
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto">
            Processo simples e rápido para conectar profissionais e clientes
          </p>
        </div>
        
        {/* Steps Grid */}
        <div className="grid grid-cols-3 md:grid-cols-3 gap-6 md:gap-8">
          {/* Step 1 */}
          <div className="text-center group">
            <div className="relative mb-6 md:mb-8">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-orange-500 rounded-xl md:rounded-3xl flex items-center justify-center mx-auto shadow-lg group-hover:shadow-xl transition-all duration-300">
                <i className="ri-edit-line text-xl md:text-2xl text-white"></i>
              </div>
              <div className="absolute -top-2 -right-2 md:-top-2 md:-right-2 w-8 h-8 md:w-8 md:h-8 bg-slate-700 rounded-full flex items-center justify-center">
                <span className="text-sm md:text-sm font-bold text-white">1</span>
              </div>
            </div>
            <h3 className="text-base md:text-xl font-semibold text-slate-900 mb-2 md:mb-3">Descreva</h3>
            <p className="text-sm md:text-base text-orange-600">Conte-nos sobre seu projeto</p>
          </div>

          {/* Step 2 */}
          <div className="text-center group">
            <div className="relative mb-6 md:mb-8">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-orange-500 rounded-xl md:rounded-3xl flex items-center justify-center mx-auto shadow-lg group-hover:shadow-xl transition-all duration-300">
                <i className="ri-search-line text-xl md:text-2xl text-white"></i>
              </div>
              <div className="absolute -top-2 -right-2 md:-top-2 md:-right-2 w-8 h-8 md:w-8 md:h-8 bg-slate-700 rounded-full flex items-center justify-center">
                <span className="text-sm md:text-sm font-bold text-white">2</span>
              </div>
            </div>
            <h3 className="text-base md:text-xl font-semibold text-slate-900 mb-2 md:mb-3">Encontre</h3>
            <p className="text-sm md:text-base text-orange-600">Receba propostas no WhatsApp</p>
          </div>

          {/* Step 3 */}
          <div className="text-center group">
            <div className="relative mb-6 md:mb-8">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-orange-500 rounded-xl md:rounded-3xl flex items-center justify-center mx-auto shadow-lg group-hover:shadow-xl transition-all duration-300">
                <i className="ri-phone-line text-xl md:text-2xl text-white"></i>
              </div>
              <div className="absolute -top-2 -right-2 md:-top-2 md:-right-2 w-8 h-8 md:w-8 md:h-8 bg-slate-700 rounded-full flex items-center justify-center">
                <span className="text-sm md:text-sm font-bold text-white">3</span>
              </div>
            </div>
            <h3 className="text-base md:text-xl font-semibold text-slate-900 mb-2 md:mb-3">Contrate</h3>
            <p className="text-sm md:text-base text-orange-600">Escolha o melhor profissional</p>
          </div>
        </div>
      </div>
    </section>
  );
};